import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import i18n from '../../../../i18next';

import OrderConfirmationScreen from '../../../../components/order/OrderConfirmationScreen';
import ApplicationStep from '../../common/ApplicationStep';

function isCapacitorIosApp() {
    try {
        return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
    } catch (_) {
        return false;
    }
}

class OrderConfirmationScreenPwa extends Component {

    constructor(props) {
        super(props);

    }

    renderContent() {

        const rootClass = isCapacitorIosApp() ? 'orderConfirmationScreenRoot' : undefined;

        return (
            <React.Fragment>
                <div className={rootClass}>
                    <OrderConfirmationScreen renderInPwa={true} history={this.props.history} />
                </div>
            </React.Fragment>
        );
    }

    render() {

        return (
            <React.Fragment>
                <ApplicationStep
                    header={true}
                    hideBackButton={true}
                    transparentHeader={false}
                    content={this.renderContent()}
                    text={i18n.t('screens:orderConfirmationScreen.orderConfirmation')}
                />
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        brandId: state.brand.id,
    };
};

export default connect(mapStateToProps, {})(OrderConfirmationScreenPwa);